module.exports = __webpack_public_path__ + "img/13.0a5837d2.png";